const initState = () => {
  return {};
}

const search = (state=initState(), action) => {
  switch (action.type) {

    case "INIT_PRESEARCH":
      return {...action.payload};

    default:
      return state;
  }
}

export default search;
